import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { LinearProgress, Container } from '@material-ui/core'

import ReaderFrame from './digiiwb-reader-frame.component'
import { useReaderContext } from './context/reader-context'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    // width: '100vw',
  },
  main: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
  },
}))

function ReaderDigiIWB() {
  const classes = useStyles()

  const {
    iRef,
    digiiwb: { url },
  } = useReaderContext()

  const [hasLoaded, setHasLoaded] = React.useState(false)

  const handleLoad = () => {
    setHasLoaded(true)
  }

  return (
    <div className={classes.root}>
      <Container maxWidth="xxl" disableGutters className={classes.main}>
        {!hasLoaded ? <LinearProgress style={{ width: '100%' }} /> : null}
        <ReaderFrame
          ref={iRef}
          variant={'digiiwb'}
          loaded={hasLoaded}
          frameSrc={url}
          onLoad={handleLoad}
        />
      </Container>
    </div>
  )
}

export default ReaderDigiIWB
